import React from 'react'
import MaterialSymbol from '../material-symbol'

const PersonAddAlt = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="person_add_alt" {...props} />
))

PersonAddAlt.displayName = 'PersonAddAlt'

export default PersonAddAlt
